import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MetaDataService } from '../metadata.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'tea-shop-fe-not-implemented',
  templateUrl: './not-implemented.component.html',
  styleUrls: ['./not-implemented.component.css'],
  standalone: false
})
export class NotImplementedComponent implements OnInit {

  path = '';

  constructor(
    private route: ActivatedRoute,
    private metaDataService: MetaDataService,
    private logger: NGXLogger,
  ) {}

  ngOnInit() {
    // Set the title of the page
    this.metaDataService.updateMetadata({
      title: 'Not Implemented - Sencha Tea',
      image: '/assets/tea-type-lady/green-tea-lady.png',
    });
    this.path = this.route.snapshot.url.join('/');
    this.logger.log('Not implemented yet');
    this.logger.log(this.route.snapshot);
    this.logger.log(this.route.pathFromRoot);
  }
}
